import React, { useState, useEffect, useContext } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import Layout from '../components/layout'
import SEO from '../components/seo'
import { GlobalStateContext } from '../context/GlobalContextProvider'
import List from '../components/List'
import MissionSeekGiveHigher from '../components/MissionSeekGiveHigher'
import PartnersList from '../components/PartnersList'
import SponsorsList from '../components/SponsorList'
import TestimonialList from '../components/TestimonialList'
import conferenceDesktop from '../images/conference-2026-1280.webp'
import conferenceDesktopLarge from '../images/conference-2026-2500.webp'
import bannerLogo from '../images/banner-mi-logo.webp'

// Served to the <picture> on mobile so the hidden desktop banner isn't downloaded
const BLANK_GIF = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='

const IndexPage = () => {
  const postDisplaySize = 4
  const MISSIONS_INTERLINK_ID = 902
  const eventsContext = useContext(GlobalStateContext)
  const [events, setEvents] = useState(eventsContext.events)
  const { eventsLoaded } = eventsContext

  const miEvents = events
    .filter(item => item.charity.id === MISSIONS_INTERLINK_ID)
    .slice(0, postDisplaySize)

  useEffect(() => {
    setEvents(eventsContext.events)
  }, [eventsContext.events])

  return (
    <Layout>
      <SEO title="Home" />

      <a
        href="https://go.missionsinterlink.org.au/national-conference-2026-824578#section-8KaRwkR"
        target="_blank"
        rel="noopener noreferrer"
        className="conference-banner"
        aria-label="Missions Interlink Conference 2026 — Register now"
      >
        <picture>
          <source media="(max-width: 768px)" srcSet={BLANK_GIF} />
          <img
            className="conference-banner__desktop"
            src={conferenceDesktop}
            srcSet={`${conferenceDesktop} 1280w, ${conferenceDesktopLarge} 2500w`}
            sizes="100vw"
            width="2500"
            height="1000"
            // React 16 doesn't know fetchPriority; the lowercase attribute passes through as-is
            // eslint-disable-next-line react/no-unknown-property
            fetchpriority="high"
            alt="Missions Interlink Conference 2026 — Anticipate: Mission now, Mission next. 14th–15th October 2026. Register now."
          />
        </picture>
        <div className="conference-banner__mobile">
          <img
            className="conference-banner__logo"
            src={bannerLogo}
            width="240"
            height="118"
            alt="Missions Interlink"
          />
          <p className="conference-banner__eyebrow">Conference 2026</p>
          <h2 className="conference-banner__title">Anticipate</h2>
          <p className="conference-banner__subtitle">Mission now, Mission next</p>
          <p className="conference-banner__date">14th &ndash; 15th October 2026</p>
          <span className="conference-banner__cta">Register Now</span>
        </div>
      </a>

      {/* Normal Banner */}
      {/* <div className="call-to-action">
        <h1 style={{ color: 'white' }} className="container call-to-action-title-1 mb-2">
          <Block contentfulID="7h5koj1xFCUbpll67JmCrX" hLevel="0" />
        </h1>
        <p className="call-to-action-title-2 mb-2">
          <Block contentfulID="2qp4eZUCOqAlotB7HtKHmQ" hLevel="0" />
        </p>
        <Link to="/membership/benefits" className="mb-5">
          <div className="btn btn-call-to-action btn-primary">Learn more</div>
        </Link>
      </div> */}

      {/* <section className="container-cards-call-to-action">
        <div className="cards-call-to-action">
          <article>
            <Block contentfulID="73j8TRJXg7kRQERo6X1tNa" hLevel="h3" />
          </article>
          <article>
            <Block contentfulID="un3Fevtzd4G5eZx5yZt2d" hLevel="h3" />
          </article>
          <article>
            <Block contentfulID="1YID5IkXwumScv9rGGyeJb" hLevel="h3" />
          </article>
          <article>
            <Block contentfulID="QKPQkwiWXIaNfkUB9eiYj" hLevel="h3" />
          </article>
        </div>
      </section> */}

      <section className="section">
        <h2>Upcoming MI Events</h2>
        <hr className="mb-2" />
        {eventsLoaded ? (
          <List data={miEvents} itemType="events" className="items-center items-container" />
        ) : (
          // Reserve the space the event cards will take so content below doesn't shift
          <div className="items-center items-container" aria-busy="true">
            {Array.from({ length: postDisplaySize }, (_, i) => (
              <div key={i} className="event-item event-item--placeholder" />
            ))}
          </div>
        )}
        <Link to="/events" className="btn btn-primary mt-2">
          See more!
        </Link>
      </section>
      <MissionSeekGiveHigher />
      <section className="section">
        <h2>Testimonials</h2>
        <hr className="mb-2" />
        <TestimonialList type={null} count={4} />
        <Link to="/testimonials" className="btn btn-primary mt-2">
          See more!
        </Link>
      </section>
      <section className="section partners-section">
        <h2>Partners</h2>
        <hr className="mb-2" />
        <PartnersList />
      </section>
      <section className="section sponsors-section">
        <h2>Sponsors</h2>
        <hr className="mb-2" />
        <SponsorsList />
      </section>
    </Layout>
  )
}

export default IndexPage

IndexPage.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string
  }).isRequired
}
